import { Configuration, PopupRequest } from "@azure/msal-browser";
import {
  AD_AUTH_AUTHORITY_URL,
  AD_AUTH_CLIENT_ID,
  AD_AUTH_REDIRECT_URI,
  AD_AUTH_SCOPE_READ,
  AD_AUTH_SCOPE_JWT
} from "./components/constants";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: AD_AUTH_CLIENT_ID,
    authority: AD_AUTH_AUTHORITY_URL,
    redirectUri: AD_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: AD_AUTH_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            // console.warn(message);
            return;
          case 2: // LogLevel.Info
            // console.info(message);
            return;
          case 3: // LogLevel.Verbose
            //  console.debug(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [AD_AUTH_SCOPE_READ]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API.
 */
export const graphTokenRequest = {
  scopes: [AD_AUTH_SCOPE_READ]
};

/**
 * Add here the scopes for your custom API (JWT token)
 */
export const jwtTokenRequest = {
  scopes: [AD_AUTH_SCOPE_JWT]
};
